// extracted by mini-css-extract-plugin
module.exports = {"content":"machines_content__3v0qU","center":"machines_center__9Mh3z"};